import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './comliancyMessages';
import MenuItemWithSecurity from '@/shared/components/MenuItemWithSecurity';
import { functionalities, privileges } from '@/shared/services/AuthService';

const CompliancyGlobalActionsButton = props => {
  const { intl, disabled, onSendEmail, onMarkComplianceTypeAsInapplicable } = props;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.RelationGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItemWithSecurity
          functionality={functionalities.Relation}
          privilege={privileges.Update}
          id="compliance-overview-global-action-toggle-inapplicable"
          onSelect={onMarkComplianceTypeAsInapplicable}
        >
          {intl.formatMessage(messages.ToggleComplianceTypeApplicable)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          id="compliance-overview-global-action-send-email"
          functionality={functionalities.InteractionsOwn}
          privilege={privileges.Create}
          onSelect={onSendEmail}
        >
          {intl.formatMessage(messages.SendEmail)}
        </MenuItemWithSecurity>
      </DropdownButton>
    </span>
  );
};

CompliancyGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  onMarkComplianceTypeAsInapplicable: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CompliancyGlobalActionsButton.defaultProps = { disabled: false };

export default injectIntl(CompliancyGlobalActionsButton);
